module.exports = __webpack_public_path__ + "static/media/video.282ea68b.mp4";